import React from "react";

export default function BioStepProgress({ steps, current }) {
  if (!steps?.length)
    return <p className="text-xs text-gray-500">Steps not defined.</p>;

  return (
    <ol className="space-y-2 text-xs">
      {steps.map((step, idx) => {
        const done = idx < current;
        const active = idx === current;

        return (
          <li key={idx} className="flex gap-2">
            <span
              className={`w-4 h-4 mt-[2px] rounded-full border flex items-center justify-center text-[10px]
                ${done ? "bg-green-500 text-white border-green-500" : ""}
                ${active ? "bg-pink-500 text-white border-pink-500" : ""}
                ${!done && !active ? "border-gray-300 text-gray-400" : ""}
              `}
            >
              {done ? "✓" : idx + 1}
            </span>

            <span
              className={`leading-snug
                ${done ? "text-gray-500 line-through" : ""}
                ${active ? "font-semibold text-pink-700" : ""}
              `}
            >
              {step}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
